import { useGetOrderDetailsQuery } from '@/affiliate-dashboard/graphql';
import { PageHeading } from '@/components/base/page-heading';
import Section from '@/components/base/section';
import { format } from 'date-fns';
import { useTranslation } from 'react-i18next';
import { useIntl } from 'react-intl';

export function OrderDetail({ orderId }: { orderId: string }) {
  const { data } = useGetOrderDetailsQuery({ variables: { orderId } });
  const orderDetails = data?.orderDetails;
  const intl = useIntl();
  const { t } = useTranslation();

  return (
    <div>
      <PageHeading>{t('orderDetail.title')}</PageHeading>
      <Section variant="secondary">
        <div className="flex w-full flex-col divide-y divide-gray-700 [&>*]:py-2">
          <div className="flex w-full justify-between">
            <span className="font-bold">{t('orderDetail.orderId')}</span>{' '}
            <span className="text-end">{orderDetails?.id}</span>
          </div>
          <div className="flex w-full justify-between">
            <span className="font-bold">{t('orderDetail.amount')}</span>
            <span>
              {intl.formatNumber(orderDetails?.amount ?? 0, {
                style: 'currency',
                currency: orderDetails?.currency ?? 'USD',
              })}
            </span>
          </div>
          <div className="flex w-full justify-between">
            <span className="font-bold">{t('orderDetail.orderNumber')}</span>
            <span>{orderDetails?.orderNumber}</span>
          </div>
          {orderDetails?.createdAt && (
            <div className="flex w-full justify-between">
              <span className="font-bold">{t('orderDetail.createdAt')}</span>
              <span>
                {format(orderDetails?.createdAt ?? '', 'dd MMM yyyy')}
              </span>
            </div>
          )}
        </div>
      </Section>
    </div>
  );
}
